/* eslint-disable consistent-return */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';
import AppRadioInput from '../../../shared/components/app-radio-input/AppRadioInput';
import AppButton from '../../../shared/components/app-button/AppButton';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
import AppAlert from '../../../shared/components/app-alert/AppAlert';
import { importPnrApi } from '../../../api/flightApi';

function ImportPnr({ onClose }) {
  const navigate = useNavigate();
  const [pnr, setPnr] = useState('');
  const [domInt, setDomInt] = useState('domestic');
  const [gdsName, setGdsName] = useState('uapi');
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const handleImportPnr = async () => {
    if (pnr === '') {
      setAlert({
        variant: 'error',
        title: 'Import PNR',
        description: 'Please enter pnr',
      });
      return false;
    }
    setIsLoading(true);
    const res = await importPnrApi(pnr, domInt, gdsName);
    if (res && res.Root && res.Root.Status === 'OK') {
      const { Result } = res.Root;
      setIsLoading(false);
      onClose(true, {
        variant: 'success',
        title: 'Import PNR',
        description: 'PNR Imported successfully, redirecting to ticket page',
      });
      setTimeout(() => {
        navigate(`/flight/ticket/${Result}`);
      }, 2000);
    } else {
      onClose(false, {
        variant: 'error',
        title: 'Import PNR',
        description: res?.Root?.Message || 'Failed to import PNR',
      });
    }
    setIsLoading(false);
  };
  return (
    <div className="d-flex flex-column gap-3">
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          description={alert.description}
          onHide={() => setAlert(undefined)}
        />
      )}
      <div className="d-flex gap-2 align-items-center justify-content-between flex-sm-row flex-column">
        <span className="fs-12">Select Travel Type</span>
        <div className="d-flex gap-2 align-items-center">
          <AppRadioInput
            labelText="Domestic"
            value="domestic"
            name="domint"
            onChange={() => setDomInt('domestic')}
            checked={domInt === 'domestic'}
          />
          <AppRadioInput
            labelText="International"
            value="international"
            name="domint"
            onChange={() => setDomInt('international')}
            checked={domInt === 'international'}
          />
        </div>
      </div>
      <div className="d-flex gap-2 align-items-center justify-content-between flex-sm-row flex-column">
        <span className="fs-12">Select Supplier</span>
        <div className="d-flex gap-2 align-items-center">
          <AppRadioInput
            labelText="UAPI"
            value="uapi"
            name="gdsname"
            onChange={() => setGdsName('uapi')}
            checked={gdsName === 'uapi'}
          />
          {/* <AppRadioInput
            labelText="Amadeus"
            value="amadeus"
            name="gdsname"
            onChange={() => setGdsName('amadeus')}
            checked={gdsName === 'amadeus'}
          /> */}
        </div>
      </div>
      <div className="mt-2">
        <AppTextInput
          name="pnr"
          id="pnr"
          label="Enter PNR"
          required
          value={pnr}
          onChange={(e) => setPnr(e.target.value)}
        />
      </div>
      <div className="d-flex justify-content-end">
        <AppButton btnText="Import PNR" onClick={handleImportPnr} />
      </div>
    </div>
  );
}

export default ImportPnr;

ImportPnr.propTypes = {
  onClose: PropTypes.func.isRequired,
};
